import app from '../angular_app.es6';

app.directive('leftRightInput', [ '$rootScope', ($rootScope) => {
  return {
    restrict: 'A',
    scope: {
      metric: '=',
      item: '=',
      upToN: '=',
      addItemIfAbstract: '=',
      attributeItemClassNames: '=',
      onAttributeKeydown: '='
    },
    template: require('./left_right_input_template.html'),
    link: ($scope) => {
      const parts = ($scope.item.question || '').split(' || ');
      $scope.leftText = parts[0] || '';
      $scope.rightText = (parts.length > 1 && parts[1]) || '';

      $scope.OnChange = () => {
        $scope.item.question = `${$scope.leftText.replaceAll('|', '')} || ${$scope.rightText.replaceAll('|', '')}`;
        $scope.addItemIfAbstract($scope.metric, $scope.item);
      };

      $scope.$watch('leftText', () => {
        $scope.leftText = $scope.leftText.replaceAll('|', '');
      });

      $scope.$watch('rightText', () => {
        $scope.rightText = $scope.rightText.replaceAll('|', '');
      });
    }
  };
} ]);
